export const SIGNED_IN_ROUTES = {
    PRIZEWINNINGSPAGE: "/home",
    LOGIN: "/login",
    LOGIN_VERIFICATION: "/login-verification",
    HOME: "/home",
    INDEX: "/index",
    PAGE0: "/onboarding/page0",
    PAGE1: "/onboarding/page1",
    PAGE2: "/onboarding/page2",
    PAGE3: "/onboarding/page3",
    PAGE4: "/onboarding/page4",
    PAGE5: "/onboarding/page5",
    PAGE6: "/onboarding/page6",
    PAGE7: "/onboarding/page7",
    PAGE8: "/onboarding/page8",
    PAGE9: "/onboarding/page9",
    PAGE10: "/onboarding/page10",
    SKILLSCRATCH_UNAVAILABLE: "/skillscratch-unavailable",
    LOADING: "/",
};
